module.exports = __webpack_public_path__ + "static/media/logokem.ad857db7.png";